import React from 'react';
import PropTypes from 'prop-types';

import { Card, Button, Popup, Divider } from 'semantic-ui-react';

const UpgradeButton = ({ onButtonClick }) => (
  <Popup
    trigger={
      <Button
        fluid
        content="upgrade now!"
        inverted
        icon="external"
        labelPosition="left"
        color="pink"
        onClick={onButtonClick}
      />
    }
    content="Clicking here will open a new window to our subscription provider Reepay."
  />
);

const AlreadyOnThisPlanButton = () => (
  <Button
    fluid
    content="Already on this plan!"
    inverted
    icon="heart"
    labelPosition="left"
    color="pink"
    disabled
  />
);

UpgradeButton.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
};

const ReepayCard = ({ onButtonClick, licenseSubscriptionType, toggleCancelModal }) => (
  <Card fluid>
    <Card.Content>
      <Card.Header>Subscription Info</Card.Header>
    </Card.Content>
    <Card.Content>
      <p>You are currently on our <strong>{licenseSubscriptionType} PLAN</strong>.</p>
    </Card.Content>
    <Card.Content>
      <Card.Group textAlign="center" itemsPerRow={3}>
        <Card color="blue">
          <Card.Content header="PREMIUM" />

          <Card.Content>
            <h2>$299</h2>
            <p>USD per month</p>
            <p>rolling monthly contract</p>
          </Card.Content>

          <Card.Content>
            {
              licenseSubscriptionType === 'PREMIUM'
                ? <AlreadyOnThisPlanButton />
                : <UpgradeButton onButtonClick={() => onButtonClick('premium')} />
            }
          </Card.Content>
          <Card.Content extra>
            {
              licenseSubscriptionType === 'PREMIUM'
                ? <p>
              click <a href="#cancel" onClick={toggleCancelModal}> here</a>
              &nbsp;to cancel this plan
                </p>
                : <Divider hidden />
            }
          </Card.Content>
        </Card>
        <Card color="green">
          <Card.Content header="PRO TEAM" />

          <Card.Content>
            <h2>$499</h2>
            <p>USD per month</p>
            <p>rolling monthly contract</p>
          </Card.Content>
          <Card.Content>
            {
              licenseSubscriptionType === 'PROTEAM'
                ? <AlreadyOnThisPlanButton />
                : <UpgradeButton onButtonClick={() => onButtonClick('proteam')} />
            }
          </Card.Content>
          <Card.Content extra>
            {
              licenseSubscriptionType === 'PROTEAM'
                ? <p>
              click <a href="#cancel" onClick={toggleCancelModal}> here</a>
              &nbsp;to cancel this plan
                </p>
                : <Divider hidden />
            }
          </Card.Content>
        </Card>

        <Card color="pink">
          <Card.Content header="ENTERPRISE" />

          <Card.Content>
            <h2>POA</h2>
            <p>whitelabel available</p>
            <p>contact us for pricing</p>
          </Card.Content>

          <Card.Content>
            <Button
              icon="comment outline"
              labelPosition="left"
              fluid
              content="contact us..."
              disabled
              inverted
              color="pink"
            />
          </Card.Content>
          <Card.Content extra>
            <Divider hidden />
          </Card.Content>
        </Card>
      </Card.Group>
    </Card.Content>
    <Card.Content extra>
      <p>
        click <a href="https://dyzio.co/pricing" rel="noopener noreferrer" target="_blank">here</a>
        &nbsp;for full pricing breakdown
      </p>
    </Card.Content>
  </Card>
);

ReepayCard.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
  licenseSubscriptionType: PropTypes.string.isRequired,
  toggleCancelModal: PropTypes.func.isRequired,
};

export default ReepayCard;



/** WEBPACK FOOTER **
 ** ./src/components/reepay-card/index.js
 **/